"use client";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./ToastComponents";
import { useToast } from "@/hooks/useToast";

interface Props {
  className?: {
    toast?: string;
    title?: string;
    description?: string;
  };
}

export function Toaster({ className }: Props) {
  const { toasts } = useToast();

  const { toast, title: titleClass, description: descClass } = className ?? {};

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, ...props }) => {
        return (
          <Toast key={id} {...props} className={toast ?? ""}>
            <div className="grid gap-1">
              {title && (
                <ToastTitle className={titleClass ?? ""}>{title}</ToastTitle>
              )}
              {description && (
                <ToastDescription className={descClass ?? ""}>
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
